import type { ActionPlanStatus } from '@/types'

interface ActionPlanStatusBadgeProps {
  status: ActionPlanStatus
  size?: 'sm' | 'md'
}

const STATUS_CONFIG: Record<ActionPlanStatus, { label: string; className: string }> = {
  draft: { label: 'Draft', className: 'bg-cfa-gray text-cfa-dark-gray' },
  active: { label: 'Active', className: 'bg-cfa-light-blue text-cfa-navy' },
  completed: { label: 'Completed', className: 'bg-success-100 text-success-700' },
  expired: { label: 'Expired', className: 'bg-warning-100 text-warning-700' },
}

export function ActionPlanStatusBadge({ status, size = 'sm' }: ActionPlanStatusBadgeProps) {
  const config = STATUS_CONFIG[status]
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm'

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${config.className} ${sizeClasses}`}>
      {config.label}
    </span>
  )
}
